import { usePageMeta } from 'src/hooks';
import { Main } from 'src/components/Layout';
import { TasksContainer } from 'src/containers/Tasks';

const TasksPage = () => {
  usePageMeta('Tasks');

  return (
    <Main title="Tasks" className="bg-background-secondary">
      <div className="container flex flex-col mx-auto min-h-full">
        <div className="shrink-0 mb-6 space-y-6">
          <div className="space-y-1">
            <div className="text-base font-semibold text-gray-700">Tasks</div>
            <p className="text-sm text-muted-foreground">
              View actions that require your attention across your organization.
            </p>
          </div>
        </div>
        <TasksContainer />
      </div>
    </Main>
  );
};

export default TasksPage;
